import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app.js';
import { AdminApp } from './admin/app.js';
import { isAdminPath } from './admin/routes.js';
import { captureInviteLink } from './flow/invite-link.js';
import './styles.css';

// The control room is decided by PATHNAME before either shell mounts — the
// api client already chose its session realm from the same pathname — so an
// operator at /admin never sees the consumer shell, and an invite link is
// a consumer concern that does not apply there.
const admin = isAdminPath(window.location.pathname);

// An invite link (/invite?token=…) is stashed BEFORE React mounts, and the tab
// moves to the invites screen — through sign-in and onboarding first if those
// are still owed; homeHash() brings the person back here when they finish.
if (!admin && captureInviteLink(window.location)) {
  window.history.replaceState(null, '', '/#/invites');
}

const host = document.getElementById('root');
if (host === null) throw new Error('#root missing from index.html');

createRoot(host).render(<StrictMode>{admin ? <AdminApp /> : <App />}</StrictMode>);
